import axios from 'axios'
import exceptionHandler from '@/common/exception-handler'
import moment from 'moment'

export async function getCompanyNewsFeed (companyId) {
  try {
    const res = await axios.get(`/api/news/${companyId}`)
    let newsFeed = res.data
    if (!newsFeed) {
      newsFeed = {
        companyId: companyId,
        articles: []
      }
    } else {
      newsFeed.articles = JSON.parse(newsFeed.articles)
    }
    return newsFeed
  } catch (error) {
    return exceptionHandler.parse(error)
  }
}

export async function saveNewsFeed (companyId, newsFeed) {
  try {
    return axios.post(`/api/news/`, {
      ...newsFeed,
      articles: JSON.stringify(newsFeed.articles)
    })
  } catch (error) {
    return exceptionHandler.parse(error)
  }
}

export function getActiveArticles (articles) {
  return articles
    .filter(it => moment(it.publishDate).isSameOrBefore(moment()) &&
      (!it.expirationDate || moment(it.expirationDate).endOf('day').isAfter(moment())))
}
